import "./styles.scoped.css";
export default {
    "root": "awsui_root_1afi9_19bf4_93",
    "hidden": "awsui_hidden_1afi9_19bf4_103",
    "no-items": "awsui_no-items_1afi9_19bf4_106"
};
